export default "__VITE_ASSET__8YzRBAW0__"